import React, { useState, useEffect } from 'react';
import DefaultAvatar from '../../images/default_avatar.jpg';
import moment from 'moment';
import { FOLLOW_STATUS, ROLES, s3Link } from '../../utils/constants';
import PSignupModal from '../../common/PSignupModal';
import PThankYou from '../../common/PThankYou';
import useDidMountEffect from '../../utils/useDidMountEffect';
import Avatar from '../../common/Avatar';
import currency from 'currency.js';
import Modal from 'react-bootstrap/Modal';
import PrivaLogo from '../../images/logos/logo-12.png';
import PUnfollow from '../../common/PUnfollow';

const ReferralRecords = () => {
    const [referrals, setReferrals] = useState([]);
    const [show, setShow] = useState(false);
    const [thankYou, setThankYou] = useState(false);
    const [activeUser, setActiveUser] = useState('');
    const [user, setUser] = useState({});
    const [followStatus, setFollowStatus] = useState(false);
    const perPage = 15;
    const [orderBy, setOrderBy] = useState('pu.login');
    const [sortBy, setSortBy] = useState('asc');
    const [isLoading, setIsLoading] = useState(false);
    const [showCcForm, setShowCcForm] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [activeFollowing, setActiveFollowing] = useState({});

    const getReferrals = async () => {
        await axios.get('/api/referrals', {
            params: {
                orderBy,
                sortBy
            }
        })
            .then(response => {
                setReferrals(response.data);
            })
            .catch(error => {
                console.log({ error });
            });
    };

    const getUserInformation = async () => {
        if (activeUser) {
            await axios.get(`/api/users/${activeUser}`)
                .then(response => {
                    setUser(response.data);
                    console.log('User to follow: ', response.data);
                })
                .catch(error => {
                    console.log({ error });
                });
        }
    };

    // useEffect(() => {
    //   getReferrals();
    // }, [])

    useDidMountEffect(() => {
        if (!thankYou && user && Object.keys(user).length > 0) {
            setShow(true);
        }
    }, [user]);

    useDidMountEffect(() => {
        if (followStatus) {
            setThankYou(true);
        }
    }, [followStatus]);

    useDidMountEffect(() => {
        if (!thankYou) {
            setShow(false);
            setActiveUser('');
            setUser({});
            setFollowStatus(false);
        }
    }, [thankYou]);

    const handleFollow = (e, referral) => {
        e.preventDefault();
        console.log({ referral });
        setActiveUser(referral.pu_id);
    };

    useDidMountEffect(() => {
        if (activeUser) {
            getUserInformation();
        }
    }, [activeUser]);

    const handleSortBy = (e, order) => {
        e.preventDefault();
        setOrderBy(order);
        setSortBy(sortBy == 'asc' ? 'desc' : 'asc');
    };

    useEffect(() => {
        let mounted = true;
        getReferrals();
        return () => {
            mounted = false;
        };
    }, [sortBy, orderBy]);

    const handleRefollow = async (e, referral) => {
        e.preventDefault();
        console.log({ e, referral });

        setIsLoading(true);
        let action = following.status == FOLLOW_STATUS.UNSUBSCRIBED ? 'followed' : 're-followed';
        await axios.patch(`/api/followings/${following.id}`, {
            action: 'refollow',
            user_id: referral.pu_id
        })
            .then(response => {
                setRefetch(true);
                addToast(`User successfully ${action}`, { appearance: 'success', autoDismiss: true });
                setIsLoading(false);
            })
            .catch(error => {
                console.log({ error });
                setActiveToFollow(following);
                if (error.response.status == 404) {
                    setShowCcForm(true);
                    addToast(
                        error.response.data.message,
                        { appearance: 'error', autoDismiss: true }
                    );
                } else {
                    addToast(
                        'Failed to process request',
                        { appearance: 'error', autoDismiss: true }
                    );
                }

                setIsLoading(false);
            });
    };

    const handleStatus = (status) => {
        console.log({ status });
    };

    useEffect(() => {
        let mounted = true;
        if (activeFollowing && Object.keys(activeFollowing).length > 0) {
            setShowModal(true);
        }

        return () => {
            mounted = false;
        };
    }, [activeFollowing]);

    const handleUnfollow = (e, following) => {
        e.preventDefault();
        setActiveFollowing(following);
    };

    return <div className="reff-list">
        {thankYou && <PThankYou show={thankYou} pu={user} setShow={setThankYou} />}
        {
            show && user && Object.keys(user).length > 0
                ? <PSignupModal
                    showModal={show}
                    setShowModal={setShow}
                    user={user}
                    type="follow"
                    setSignupFormStatus={() => ({})}
                    setFollowStatus={setFollowStatus}
                    getUserInformation={getReferrals}
                />
                : ''
        }
        <div className="reff-list-inner">
            <div className="reff-list-head">
                <div className="reff-user-row">
                    <div className="ref-user">
                        {
                            orderBy == 'pu.login'
                                ? <span><a href="#" onClick={e => handleSortBy(e, 'pu.login')}>Referral</a>  {sortBy == 'asc' ? ' ▲ ' : ' ▼ '}</span>
                                : <span style={{ cursor: 'pointer' }} onClick={e => handleSortBy(e, 'pu.login')}>Referral</span>
                        }
                    </div>
                    <div className="curr-earn">
                        {
                            orderBy == 'month_total'
                                ? <span>
                                    <a href="#" onClick={e => handleSortBy(e, 'month_total')}>
                                        Current Month<br />Earnings
                                    </a> {sortBy == 'asc' ? ' ▲ ' : ' ▼ '}
                                </span>
                                : <span style={{ cursor: 'pointer' }} onClick={e => handleSortBy(e, 'month_total')}>Current Month  <br />Earnings</span>
                        }
                    </div>
                    <div className="curr-earn">
                        {
                            orderBy == 'earning_total'
                                ? <span>
                                    <a href="#" onClick={e => handleSortBy(e, 'earning_total')}>
                                        Total Referral<br />Earnings
                                    </a> {sortBy == 'asc' ? ' ▲ ' : ' ▼ '}
                                </span>
                                : <span style={{ cursor: 'pointer' }} onClick={e => handleSortBy(e, 'earning_total')}>Total Referral<br />Earnings</span>
                        }
                    </div>
                    <div className="ref-subscr">
                        {orderBy == 'pu.creator.subscription_price'
                            ? <span><a href="#" onClick={e => handleSortBy(e, 'pu.creator.subscription_price')}>
                                Subscription
                            </a>  {sortBy == 'asc' ? ' ▲ ' : ' ▼ '}</span>
                            : <span style={{ cursor: 'pointer' }} style={{ cursor: 'pointer' }} onClick={e => handleSortBy(e, 'pu.creator.subscription_price')}>Subscription</span>
                        }
                        <span className="ref-usd-txt">(USD per month)</span>
                    </div>
                    <div className="reff-follow" />
                </div>
            </div>
            <div className="reff-list-body">
                {
                    referrals.length > 0 && referrals.map(referral => {
                        return <div className="reff-user-row" key={referral.id}>
                            <div className="ref-user">
                                <div className="ref-user-img">
                                    <div className="ref-user-img-overflow">
                                        {referral.pu ? <Avatar pu={referral.pu} size="60" story={false} /> : ''}
                                    </div>
                                </div>
                                <div className="ref-user-detail">
                                    <div className="ref-user-name">
                                        {referral.pu ? referral.pu.firstname : ''} {referral.pu ? referral.pu.lastname : ''}
                                    </div>
                                    <div className="ref-user-email">
                                        {
                                            referral.pu
                                                ? <a href={`${process.env.MIX_APP_URL}/${referral.pu.login || ''}`}>@{referral.pu.login}</a>
                                                : 'No information'
                                        }
                                    </div>
                                    <div className="ref-user-date">
                                        {
                                            referral.pu
                                                ? `Joined ${moment.utc(referral.pu.registered).local().format('MMM YYYY')}`
                                                : ''
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="curr-earn">
                                {currency(parseFloat(referral.month_total)).format()}
                            </div>
                            <div className="curr-earn">{currency(parseFloat(referral.earning_total)).format()}</div>
                            <div className="ref-subscr">{referral.pu && referral.pu.creator ? currency(referral.pu.creator.subscription_price).format() : '$0.00'}</div>
                            <div className="reff-follow">
                                {/* {
                  referral.pu && [FOLLOW_STATUS.UNSUBSCRIBED, false].includes(referral.pu.subscription_status) && referral.pu.role === ROLES.PU
                    ? <a
                      href=""
                      className="btn theme-btn theme-btn-bordered"
                      onClick={(e) => handleFollow(e, referral)}
                    >Follow</a>
                    : ''
                }
                {
                  referral.pu && referral.pu.subscription_status === FOLLOW_STATUS.ACTIVE && referral.pu.role === ROLES.PU
                  ? <button className='btn btn-link'>Unfollow</button>
                  : ''
                }
                {
                  referral.pu && referral.pu.subscription_status === FOLLOW_STATUS.UNFOLLOWED_DOES_NOT_RENEW && referral.pu.role === ROLES.PU
                    ? <a
                      href=""
                      className="btn theme-btn theme-btn-bordered"
                      onClick={(e) => handleRefollow(e, referral)}
                    >Refollow</a>
                    : ''
                } */}
                            </div>
                        </div>;
                    })
                }
            </div>
        </div>
        {/* Hide
      { showModal && <PUnfollow show={showModal} setShow={setShowModal} activeFollowing={activeFollowing} handleStatus={handleStatus} /> }
      {showCcForm && <Modal className="modalpayment" show={showCcForm} onHide={setPaymentShow} size="md" backdrop="static" keyboard={false} centered>
          <Modal.Header closeButton>
              <a href="/"><img src={PrivaLogo} /></a>
          </Modal.Header>
          <Modal.Body>
              <CCForm user={activeToFollow.following_information} setPaymentShow={setPaymentShow} setAddCardStatus={setAddCardStatus} intent={'follow'} />
          </Modal.Body>
      </Modal>} */}
    </div>;
};

export default ReferralRecords;
